import React from 'react'
import "98.css"
import { hiscoresAPI } from './api/hiscores.js'

export default class Snake extends React.Component {
    
    componentDidMount() {

        if (!document.querySelector('.start-menu-wrapper').classList.contains('hidden')){
            document.querySelector('.start-menu-wrapper').classList.add('hidden')
        }

        document.querySelector('.window-container').append(document.querySelector('.window[data-name="snake.exe"]'));

        const board = document.getElementById('game-board')
        const startScreen = document.getElementById('start-screen')
        const menuScreen = document.getElementById('menu-screen')
        const leaderBoards = document.getElementById('leaderboard')
        //const gameBorder2 = document.querySelector('.game-border-2')
        const gameBorder3 = document.querySelector('.game-border-3')
        const scores = document.querySelector('.scores')
        //const instructionText = document.getElementById('instruction-text')
        //const logo = document.getElementById('logo')
        const score = document.getElementById('score')
        //const highScoreText = document.getElementById('highScoreValue')

        let playerName = ''
        if (localStorage.getItem('snake_username')) {
            playerName = localStorage.getItem('snake_username')
        }
        //console.log(playerName)

        const gridSize = 20
        let snake = [{x : 10, y : 10}, {x : 10, y : 9  }]
        let food = generateFood()
        let highScoreValue = 0
        let highScoreLocalValue = 0
        let direction = 'right'
        let gameInterval
        let gameSpeedDelay = 190
        let gameStarted = false

        function load() {
            // if (localStorage.getItem('snake-top-score')) {
            //     snakeTopScore = localStorage.getItem('snake-top-score').padStart(3, '0')
            // } else {
            //     snakeTopScore = '000'
            // }
            var snakeData = JSON.parse(localStorage.getItem('snakeData'))
            if (snakeData && snakeData[playerName] && snakeData[playerName]['top-score']) {
                highScoreLocalValue = snakeData[playerName]['top-score']
                //console.log('local hiscore = ' + highScoreLocalValue)
                document.getElementById('highScoreLocalValue').innerText = snakeData[playerName]['top-score'].toString().padStart(3, '0')
            } else {
                //console.log('local hiscore = ' + highScoreLocalValue)
                document.getElementById('highScoreLocalValue').innerText = '000'
            }
            getRankOneScore()
            var opacityLevel = 0.1
            var startup = setInterval(() => {
                startScreen.style.opacity = opacityLevel
                opacityLevel += 0.1
                if (opacityLevel >= 1) {
                    clearInterval(startup)
                }
            }, 200)
            setTimeout(() => {
                startScreen.style.display = 'none'
                menuScreen.classList.remove('hidden')
                document.getElementById('snake_username').value = playerName
            }, 3000)
        }

        function draw() {
            board.innerHTML = ''
            drawSnake()
            drawFood()
            updateScore()
        }

        function drawSnake() {
            if (gameStarted) {
                snake.forEach((segment) => {
                    const snakeElement = createGameElement('div', 'snake')
                    setPosition(snakeElement, segment)
                    board.appendChild(snakeElement)
                })
            }
        }

        function createGameElement(tag, className) {
            const element = document.createElement(tag)
            element.className = className
            return element
        }

        function setPosition(element, position) {
            element.style.gridColumn = position.x
            element.style.gridRow = position.y
        }

        function drawFood() {
            if (gameStarted) {
                const foodElement = createGameElement('div', 'food')
                foodElement.innerHTML = '<div class="food-inner"></div>'
                setPosition(foodElement, food)
                board.appendChild(foodElement)
            }
        }

        function generateFood() {
            const x = Math.floor(Math.random() * gridSize) + 1
            const y = Math.floor(Math.random() * gridSize) + 1
            return {x, y}
        }

        function move() {
            const head = {...snake[0]}
            switch (direction) {
                case 'up':
                    head.y--
                    break
                case 'down':
                    head.y++
                    break
                case 'right':
                    head.x++
                    break
                case 'left':
                    head.x--
                    break
            }

            snake.unshift(head)

            if (head.x === food.x && head.y === food.y) {
                food = generateFood()
                increaseSpeed()
                clearInterval(gameInterval)
                gameInterval = setInterval(() => {
                    move()
                    checkCollision()
                    draw()
                }, gameSpeedDelay)
            } else {
                snake.pop()
            }
        }

        function startGame() {
            gameStarted = true
            //instructionText.style.display = 'none'
            //logo.style.display = 'none'
            playerName = document.getElementById('snake_username').value.toUpperCase()
            localStorage.setItem('snake_username', playerName)
            var snakeData = JSON.parse(localStorage.getItem('snakeData'))
            if (snakeData && snakeData[playerName] && snakeData[playerName]['top-score']) {
                highScoreLocalValue = snakeData[playerName]['top-score']
                //console.log('local hiscore = ' + highScoreLocalValue)
                document.getElementById('highScoreLocalValue').innerText = snakeData[playerName]['top-score'].toString().padStart(3, '0')
            } else {
                highScoreLocalValue = 0
                //console.log('local hiscore = ' + highScoreLocalValue)
                document.getElementById('highScoreLocalValue').innerText = highScoreLocalValue.toString().padStart(3, '0')
            }
            menuScreen.classList.add('hidden')
            leaderBoards.classList.add('hidden')
            gameBorder3.classList.remove('not-visible')
            scores.classList.remove('not-visible')
            
            gameInterval = setInterval(() => {
                move()
                checkCollision()
                draw()
            }, gameSpeedDelay)
        }

        // function handleKeyPress(event) {
        //     if ((!gameStarted && event.code === 'Space') ||
        //     (!gameStarted && event.code === ' ')) {
        //         startGame()
        //     } else {
        //         switch (event.key) {
        //             case 'ArrowUp':
        //             //direction = 'up'
        //             document.querySelector('.control-button[data-number="2"]').click()
        //             break
        //             case 'ArrowDown':
        //             //direction = 'down'
        //             document.querySelector('.control-button[data-number="8"]').click()
        //             break
        //             case 'ArrowLeft':
        //             //direction = 'left'
        //             document.querySelector('.control-button[data-number="4"]').click()
        //             break
        //             case 'ArrowRight':
        //             //direction = 'right'
        //             document.querySelector('.control-button[data-number="6"]').click()
        //             break
        //         }
        //     }
        // }

        function handleKeyPress(event) {
            if (((!gameStarted && event.code === 'Space') ||
            (!gameStarted && event.code === ' ')) && document.querySelector('#start-screen').style.display === 'none') {
                startGame()
            } else {
                if (event.key === 'ArrowUp' && direction !== 'down') {
                    direction = 'up'
                } else if (event.key === 'ArrowDown' && direction !== 'up') {
                    direction = 'down'
                } else if (event.key === 'ArrowLeft' && direction !== 'right') {
                    direction = 'left'
                } else if (event.key === 'ArrowRight' && direction !== 'left') {
                    direction = 'right'
                }
            }
        }

        // function mobileButtons(e) {
        //     var number = e.target.getAttribute('data-number')
        //     switch (number) {
        //         case '2':
        //             direction = 'up'
        //             break
        //             case '8':
        //             direction = 'down'
        //             break
        //             case '4':
        //             direction = 'left'
        //             break
        //             case '6':
        //             direction = 'right'
        //             break
        //     }
        // }
        
        // function mobileButtons(e) {
        //     var number = parseInt(e.target.getAttribute('data-number'))
        //     if (number === 2 && direction !== 'down') {
        //         direction = 'up'
        //     } else if (number === 8 && direction !== 'up') {
        //         direction = 'down'
        //     } else if (number === 4 && direction !== 'right') {
        //         direction = 'left'
        //     } else if (number === 6 && direction !== 'left') {
        //         direction = 'right'
        //     }
        // }

        function increaseSpeed() {
            // console.log(gameSpeedDelay)
            if (gameSpeedDelay > 150) {
                gameSpeedDelay -= 5
            } else if (gameSpeedDelay > 100) {
                gameSpeedDelay -= 3
            } else if (gameSpeedDelay > 50) {
                gameSpeedDelay -= 2
            } else if (gameSpeedDelay > 25) {
                gameSpeedDelay -= 1
            }
        }

        function checkCollision() {
            const head = snake[0]

            if (head.x < 1 || head.x > gridSize || head.y < 1 || head.y > gridSize) {
                resetGame()
            }

            for (let i=1; i < snake.length; i++) {
                if (head.x === snake[i].x && head.y === snake[i].y) {
                    resetGame()
                }
            }

        }

        function resetGame() {
            // console.log('resetting')
            updateHighScore()
            stopGame()
            snake = [{x: 10, y: 10}, {x: 10, y: 9}, ]
            food = generateFood()
            direction = 'right'
            gameSpeedDelay = 200
            updateScore()
        }
        
        function updateScore() {
            const currentScore = snake.length - 2
            //console.log(currentScore)
            score.textContent = currentScore.toString().padStart(3, '0')
        }

        function stopGame() {
            clearInterval(gameInterval)
            gameStarted = false
            //instructionText.style.display = 'block'
            //logo.style.display = 'block'
            menuScreen.classList.remove('hidden')
            gameBorder3.classList.add('not-visible')
            scores.classList.add('not-visible')
        }

        async function loadLeaderboard() {
            const highScores = await hiscoresAPI.getHighScores(null, 100)
        
            const leaderboardBody = document.querySelector('.leaderboard-table tbody.leaderboard-data')

            // Clear existing content
            leaderboardBody.innerHTML = ''
            
            // Generate HTML rows
            if (highScores && highScores.length > 0) {
                highScores.forEach((scoreEntry, index) => {
                    const row = document.createElement('tr')
                    row.innerHTML = `
                        <td>${index + 1}</td>
                        <td>${scoreEntry.playerName}</td>
                        <td>${scoreEntry.score}</td>
                    `
                    leaderboardBody.appendChild(row)
                })
            } else {
                // Show message if no scores
                const row = document.createElement('tr')
                row.innerHTML = `
                    <td colspan="3" style="text-align: center; font-style: italic;">
                        No high scores yet.
                    </td>
                `
                leaderboardBody.appendChild(row)
            }
        }

        function openLeaderboards() {
            leaderBoards.classList.remove('hidden')
            menuScreen.classList.add('hidden')
            loadLeaderboard()
        }

        function returnHome() {
            leaderBoards.classList.add('hidden')
            menuScreen.classList.remove('hidden')
        }

        async function getRankOneScore() {
            try {
                // Get just the top score (limit 1)
                const highScores = await hiscoresAPI.getHighScores(null, 1)
                var globalTopScore
                if (highScores && highScores.length > 0) {
                    const topScore = highScores[0]
                    //console.log(topScore.score)
                    globalTopScore = topScore.score
                    // return {
                    //     score: topScore.score
                    // }
                } else {
                    // No scores exist yet
                    globalTopScore = '0'
                    // return null
                }

                highScoreValue = globalTopScore
                //console.log('global hiscore = ' + highScoreValue)
                document.getElementById('highScoreValue').innerText = globalTopScore.toString().padStart(3, '0')
                
            } catch (error) {
                console.error('Failed to get rank 1 score:', error)
                return null
            }
        }

        async function updateHighScore() {
            const currentScore = snake.length - 2

            if (currentScore > highScoreValue) {
                //NEW GLOBAL HISCORE
                highScoreValue = currentScore
                //console.log('global hiscore = ' + highScoreValue)
                document.getElementById('highScoreValue').innerText = highScoreValue.toString().padStart(3, '0')

                playerName = playerName ? playerName : 'NONAME'

                if (localStorage.getItem('snakeData')) {
                    var snakeData = JSON.parse(localStorage.getItem('snakeData'))

                    if (snakeData[playerName]) {
                        snakeData[playerName]['top-score'] = highScoreLocalValue
                        localStorage.setItem('snakeData', JSON.stringify(snakeData))
                    } else {
                        snakeData[playerName] = {
                            "username" : playerName,
                            "top-score" : highScoreValue
                        }
                        localStorage.setItem('snakeData', JSON.stringify(snakeData))
                    }
                } else {
                    var snakeData = {}
                    snakeData = { ...snakeData, [playerName]: {"username" : playerName,  "top-score" : highScoreLocalValue} }
                    localStorage.setItem('snakeData', JSON.stringify(snakeData))
                }
            }

            if (currentScore > highScoreLocalValue) {
                //NEW LOCAL HISCORE
                highScoreLocalValue = currentScore
                document.getElementById('highScoreLocalValue').innerText = highScoreLocalValue.toString().padStart(3, '0')

                playerName = playerName ? playerName : 'NONAME'

                if (localStorage.getItem('snakeData')) {
                    var snakeData = JSON.parse(localStorage.getItem('snakeData'))

                    if (snakeData[playerName]) {
                        snakeData[playerName]['top-score'] = highScoreLocalValue
                        localStorage.setItem('snakeData', JSON.stringify(snakeData))
                    } else {
                        snakeData[playerName] = {
                            "username" : playerName,
                            "top-score" : highScoreLocalValue
                        }
                        localStorage.setItem('snakeData', JSON.stringify(snakeData))
                    }
                } else {
                    var snakeData = {}
                    snakeData = { ...snakeData, [playerName]: {"username" : playerName,  "top-score" : highScoreLocalValue} }
                    localStorage.setItem('snakeData', JSON.stringify(snakeData))
                }

                // var snakeData = {
                //     "username" : playerName,
                //     "top-score" : highScoreValue
                // }
                // localStorage.setItem('snakeData', JSON.stringify(snakeData))
                // highScoreText.textContent = "Top score: " + highScoreValue.toString().padStart(3, '0')

            }

            try {
                const result = await hiscoresAPI.submitScore({
                playerName: playerName ? playerName.toUpperCase() : 'NONAME',
                score: currentScore,
                gameMode: 'snake'
                })
            } catch (error) {
                alert('Failed to save score: ' + error.message)
            }

            //highScoreText.style.display = 'block'
        }

        load()
        document.addEventListener('keydown', handleKeyPress)
        menuScreen.querySelector('.new-game').addEventListener('click', startGame)
        menuScreen.querySelector('.leaderboards').addEventListener('click', openLeaderboards)
        leaderBoards.querySelector('.home-return').addEventListener('click', returnHome)
        
        // document.querySelectorAll('.control-button').forEach(button => {
        //     button.addEventListener('click', mobileButtons)
        // })
        document.querySelector('.control-button[data-number="2"]').addEventListener('click', function() {
            if (direction !== 'down') {
                direction = 'up'
            }
        })
        document.querySelector('.control-button[data-number="8"]').addEventListener('click', function() {
            if (direction !== 'up') {
                direction = 'down'
            }
        })
        document.querySelector('.control-button[data-number="4"]').addEventListener('click', function() {
            if (direction !== 'right') {
                direction = 'left'
            }
        })
        document.querySelector('.control-button[data-number="6"]').addEventListener('click', function() {
            if (direction !== 'left') {
                direction = 'right'
            }
        })
    }

    render() {
        return (
            <div className="window active" data-name="snake.exe" onClick={this.props.onReOpen}>

                <div className="title-bar">
                    <div className="title-bar-text">snake.exe</div>
                    <div className="title-bar-controls">
                        <button className="form-minimise" aria-label="Minimize" onClick={this.props.onMinimise} data-name="snake.exe"></button>
                        <button className="form-close" aria-label="Close" onClick={this.props.onClose} data-name="snake.exe"></button>
                    </div>
                </div>

                <div className="window-body">
                     
                    <div className="game-border-2">
                        <div className="scores not-visible">
                            <p id="score">000</p>
                            {/*<p id="highScore">000</p>*/}
                        </div>
                        <div className="game-border-3 not-visible">
                            <div id="game-board"></div>
                        </div>
                    </div>
                    <div id="leaderboard" className="hidden">
                        <div className="menu-text">Hi-scores</div>
                        <div className="leaderboard-table">
                            <table>
                                <tbody>
                                    <tr>
                                        <th>Rank</th>
                                        <th>Username</th>
                                        <th>Score</th>
                                    </tr>
                                </tbody>
                                <tbody className="leaderboard-data">
                                </tbody>
                            </table>
                        </div>
                        <div className="menu-text-sml home-return">Back to Main Menu</div>
                    </div>
                    <div id="menu-screen" className="hidden">
                        <img className="logo" src="images/snake-game.png" alt="snake-logo"></img>
                        <div id="highScore">Global Top Score: <span id="highScoreValue"></span></div>
                        <div id="highScoreLocal">Top Score: <span id="highScoreLocalValue"></span></div>
                        <div className="menu-text mobile new-game">New Game</div>
                        <div className="menu-text desktop new-game">Press Space To Start</div>
                        <div className="menu-text-sml">Name: <label htmlFor="snake_username"></label><input id="snake_username" className="menu-text-sml" type="text" maxLength="6"/></div>
                        <div className="menu-text-sml leaderboards">Leaderboards</div>
                    </div>
                    <div id="start-screen">
                        <img className="logo" src="images/snake-game.png" alt="snake-logo"></img>
                    </div>
                </div>

                <div className="controls">
                    <div className="control-buttons">
                        {/* <div className="control-button-container" data-number="2"> */}
                            <button className="control-button" data-number="2">
                                <div className="icon" style={{backgroundPosition: "0px 0px"}}></div>
                            </button>
                        {/* </div> */}
                        {/* <div className="control-button-container" data-number="4"> */}
                            <button className="control-button" data-number="4">
                                <div className="icon" style={{backgroundPosition: "0px 0px"}}></div>
                            </button>
                        {/* </div> */}
                        {/* <div className="control-button-container" data-number="6"> */}
                            <button className="control-button" data-number="6">
                                <div className="icon" style={{backgroundPosition: "0px 0px"}}></div>
                            </button>
                        {/* </div> */}
                        {/* <div className="control-button-container" data-number="8"> */}
                            <button className="control-button" data-number="8">
                                <div className="icon" style={{backgroundPosition: "0px 0px"}}></div>
                            </button>
                        {/* </div> */}
                    </div>
                </div>

                <p className="center instruction-text">Use your arrow keys</p>

            </div>
        )
    }
}